import { useEffect, useState } from 'react'

import { localStorageService } from '@/service/storage.service'

/** Toggle label 상수 */
export const STUDENT_LIST_OPEN_LABEL = '학생 목록 항상 열어서 보기'

type UseStudentListOpenStateOptions = {
  /** localStorage에 값이 없을 때 사용할 기본값 (default: false) */
  fallbackValue?: boolean
}

/**
 * 학생 목록 펼침 상태 관리 훅
 * localStorage에 저장하여 모달 간 상태 유지
 */
export const useStudentListOpenState = (options?: UseStudentListOpenStateOptions) => {
  const { fallbackValue = false } = options ?? {}
  const [isDefaultOpen, setIsDefaultOpen] = useState(() => {
    const saved = localStorageService.getItem('MODAL_STUDENT_OPEN_STATE')
    if (saved !== null) return saved
    return fallbackValue
  })

  // unmount 시 localStorage에 저장
  useEffect(() => {
    return () => {
      localStorageService.setItem('MODAL_STUDENT_OPEN_STATE')(isDefaultOpen)
    }
  }, [isDefaultOpen])
  return { isDefaultOpen, setIsDefaultOpen }
}

export default useStudentListOpenState
